import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { QualitativeInputActions } from './qualitative-input.actions';
import { QualitativeProcess } from '../../../../graphql/generated';
import { convertListoToOptions } from '../../shared/ra.operations';

export const qualitativeInputsFeatureKey = 'qualitativeInputs';

export interface State extends EntityState<QualitativeProcess> {
  loading: boolean;
  loadingCell: any;
  questionsLength: number;
  filters: any;
  totalElements: any;
}

export const adapter: EntityAdapter<QualitativeProcess> = createEntityAdapter<QualitativeProcess>({
  selectId: (qualitative: QualitativeProcess) => qualitative.cptCatalogue!.id!
});

export const initialState: State = adapter.getInitialState({
  loading: false,
  loadingCell: {},
  filters: {},
  questionsLength: 0,
  totalElements: 0
});

export const reducer = createReducer(
  initialState,
  on(QualitativeInputActions.loadQualitativeInputs,
    (state) => ({
      ...state,
      loading: true
    })
  ),
  on(QualitativeInputActions.loadQualitativeInputsSuccess, (state, action) => ({
    ...adapter.setAll(action.qualitative as QualitativeProcess[], state),
    // filters: buildGenericFilters(action.qualitative as QualitativeProcess[]),
    totalElements: action.totalElements,
    loading: false
  })),
  on(QualitativeInputActions.loadQualitativeInputsFailure, (state, action) => ({
    ...state,
    loading: false
  })),
  on(QualitativeInputActions.loadAllQualitativeInputs,
    (state) => ({
      ...state
    })
  ),
  on(QualitativeInputActions.loadAllQualitativeInputsSuccess, (state, action) => ({
    ...state,
    filters: buildGenericFilters(action.qualitative as QualitativeProcess[])
  })),
  on(QualitativeInputActions.loadAllQualitativeInputsFailure, (state, action) => ({
    ...state
  })),
  on(QualitativeInputActions.clearQualitativeInputs,
    state => adapter.removeAll(state)
  ),
  on(QualitativeInputActions.updateQualitativeInput,
    (state, action) => ({
      ...state,
      loadingCell: {
        ...state.loadingCell,
        [action.cptId]: [
          ...(state.loadingCell?.[action.cptId] ?? []),
          action.questionId
        ]
      }
    })
  ),
  on(QualitativeInputActions.updateQualitativeInputSuccess, (state, action) => ({
    ...state,
    loading: false,
    loadingCell: {
      ...state.loadingCell,
      [action.cptId]: (state.loadingCell[action.cptId] as any[]).filter(questionId => questionId !== action.questionId)
    }
  })),
  on(QualitativeInputActions.updateQualitativeInputFailure, (state, action) => ({
    ...state,
    loading: false,
    loadingCell: {
      ...state.loadingCell,
      [action.cptId]: (state.loadingCell[action.cptId] as any[]).filter(questionId => questionId !== action.questionId)
    }
  })),
  on(QualitativeInputActions.createQualitativeInput, (state, action) => ({
    ...state,
    loadingCell: {
      ...state.loadingCell,
      [action.cptId]: [
        ...(state.loadingCell?.[action.cptId] ?? []),
        action.questionId
      ]
    }
  })),
  on(QualitativeInputActions.createQualitativeInputSuccess, (state, action) => ({
    ...state,
    loading: false,
    loadingCell: {
      ...state.loadingCell,
      [action.cptId]: (state.loadingCell[action.cptId] as any[]).filter(questionId => questionId !== action.questionId)
    }

  })),
  on(QualitativeInputActions.createQualitativeInputFailure, (state, action) => ({
    ...state,
    loading: false,
    loadingCell: {
      ...state.loadingCell,
      [action.cptId]: (state.loadingCell[action.cptId] as any[]).filter(questionId => questionId !== action.questionId)
    }
  }))
);

export const qualitativeInputsFeature = createFeature({
  name: qualitativeInputsFeatureKey,
  reducer,
  extraSelectors: ({
    selectQualitativeInputsState,
    selectIds,
    selectFilters,
    selectEntities
  }) => ({
    ...adapter.getSelectors(selectQualitativeInputsState),
    selectQualitativeInputList: createSelector(
      selectEntities,
      selectIds,
      (entities, ids) => {
        return entities ? ids.map<QualitativeProcess>((id) => entities[id] as QualitativeProcess) : [];
      }
    ),
    selectQualitativeNotCompletedInputList: createSelector(
      selectQualitativeInputsState,
      selectEntities,
      selectIds,
      (state, entities, ids) => {
        // return entities ? ids.map<QualitativeProcess>((id) => entities[id] as QualitativeProcess).filter(question => (question.questions ?? []).filter(ques => ques?.question?.ansGrp?.group !== 'text' && ques?.id).length !== (state.questionsLength - countTextQuestions(question?.questions ?? []))) as QualitativeProcess[] : [];
        return entities ? ids.map<QualitativeProcess>((id) => entities[id] as QualitativeProcess) : [];

      }
    ),
    selectNames: (fieldName: string) =>
      createSelector(selectFilters, (filters) =>
        convertListoToOptions(filters?.[fieldName] || [])
      )
  })
});

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectLoading,
  selectQualitativeInputList,
  selectTotal,
  selectFilters,
  selectQualitativeInputsState,
  selectLoadingCell,
  selectQualitativeNotCompletedInputList,
  selectTotalElements,
  selectNames
} = qualitativeInputsFeature;


function buildGenericFilters(entity: QualitativeProcess[]) {
  return {
    'code': entity.map(e => e.cptCatalogue?.code) || [],
    'name': entity.map(e => e.cptCatalogue?.name) || []
  }

}
function countTextQuestions(question: any[]): number {
  return question.filter(ques => ques?.question?.ansGrp?.group !== 'text').length
}

